import { DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import React from "react";
import { DialogContentSuccessText } from "../../../../functions/errorHandling";
import ISkywardIntegrationTokenPair from "../../../../models/ISkywardIntegrationTokenPair";
import snackbarService from "../../../../services/ui-messaging/SnackbarService";
import { RawLinkButton } from "../../../LinkButton";
import styled from "styled-components";

const WrapText = styled(DialogContentText)`
  overflow-wrap: anywhere;
`;

export interface ITokenResultDisplayProps {
  tokenPair: ISkywardIntegrationTokenPair;
  onClose: () => void;
}

export const TokenResultDisplay = (props: ITokenResultDisplayProps): JSX.Element => {
  const { tokenPair, onClose } = props;
  const [didCopy, setDidCopy] = React.useState<boolean>(false);

  const lines: Array<string> = ["Skyward Integration Token"];
  if (tokenPair.SkywardIntegrationToken1 !== null) {
    lines.push(`Token 1 - ${tokenPair.SkywardIntegrationToken1}`);
  }
  if (tokenPair.SkywardIntegrationToken2 !== null) {
    lines.push(`Token 2 - ${tokenPair.SkywardIntegrationToken2}`);
  }

  const onCopy = async () => {
    await navigator.clipboard.writeText(lines.join("\n"));
    snackbarService.success("Successfully copied Skyward Integration Token to clipboard");
    setDidCopy(true);
  };

  return (
    <>
      <DialogContent>
        <DialogContentSuccessText>New Skyward Integration Token</DialogContentSuccessText>
        <DialogContentSuccessText>Use the button below to copy this information before closing this screen.</DialogContentSuccessText>
        {lines.map((line, key) => (
          <WrapText key={key}>{line}</WrapText>
        ))}
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={onCopy}>Copy to Clipboard</RawLinkButton>
        <RawLinkButton onClick={onClose} disabled={!didCopy}>
          Close
        </RawLinkButton>
      </DialogActions>
    </>
  );
};
